import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('appDriverCreditCards/getData', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverCreditCards', params, {mode:'cors'})
      return {
         params,
         data: response.data,
         allData: response.data.allData
      }
   })

   export const editDriverAdjustments = createAsyncThunk('appDriverCreditCards/editDriverAdjustments',  async (EditAdjustments) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetAdjustmentsData', EditAdjustments, {mode:'cors'})
      return response
   })

   export const deletedriverAdjustments = createAsyncThunk('appCreditNote/deletedriverAdjustments', async (DeleteAdjustments) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/DeleteAdjustments', DeleteAdjustments, {mode:'cors'})
      return response.data
   })
  export const deletedriverFixedAdjustments = createAsyncThunk('appCreditNote/deletedriverAdjustments', async (DeleteAdjustments) => {
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteDriverPaymentAdjustment', DeleteAdjustments, {mode:'cors'})
    
      return response.data
   })
   export const deleteDriverFixedDeduction = createAsyncThunk('appDriverCreditCards/deleteDriverFixedDeduction', async (Obj) => {
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteDriverFixedDeduction', Obj, {mode:'cors'})
      return response.data
   })
   export const getCreditCardsData = createAsyncThunk('appDriverCreditCards/getCreditCardsData', async (GetCCDetails) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverCreditCards', GetCCDetails, {mode:'cors'})
      return response.data
   })

   export const getAdjustmentsData = createAsyncThunk('appDriverCreditCards/getAdjustmentsData',  async (AdjustmentsData) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetAdjustmentsData', AdjustmentsData, {mode:'cors'})
      return response.data
   })
      export const getFixedAdjustmentsData = createAsyncThunk('appDriverCreditCards/getFixedAdjustmentsData',  async (AdjustmentsData) => {
    
         const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriverPaymentAdjustments', AdjustmentsData, {mode:'cors'})
      return response.data
   })

   export const syncAndGetFixedAdjustments = createAsyncThunk('appDriverCreditCards/syncAndGetFixedAdjustments', async (Obj) => {
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/SyncAndGetFixedAdjustments', Obj, {mode:'cors'})
      return response.data
   })
   export const getDriverFixedDeductionData = createAsyncThunk('appDriverCreditCards/getDriverFixedDeductionData',  async (Obj) => {
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriverFixedDeductions', Obj, {mode:'cors'})
      return response.data
   })
   
   export const fetchDriverAdjustmentsDetailList = createAsyncThunk('appDriverCreditCards/fetchDriverAdjustmentsDetailList',  async (AdjustmentsData) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverAdjustmentsDetail', AdjustmentsData, {mode:'cors'})
      return response.data
   })
export const getfrequencyplanList = createAsyncThunk('appDriver/getfrequencyplanList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetfrequencyplanList')
  return response.data
})
   export const addAdjustments = createAsyncThunk('appDriverCreditCards/addAdjustments',  async (AddAdjustment) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/CreateAdjustment', AddAdjustment, {mode:'cors'})
      return response
   })
 export const addFixedAdjustments = createAsyncThunk('appDriverCreditCards/addFixedAdjustments',  async (AddAdjustment) => {
      
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/AddDriverPaymentAdjustments', AddAdjustment, {mode:'cors'})
      return response
   })

   export const addDriverFixedDeduction = createAsyncThunk('appDriverCreditCards/addDriverFixedDeduction',  async (Obj) => {
      const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/AddDriverFixedDeduction', Obj, {mode:'cors'})
      return response
   })
   export const editAdjustments = createAsyncThunk('appDriverCreditCards/editAdjustments', async (UpdateAdjustment) => {
     
      const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateAdjustments', UpdateAdjustment, {mode:'cors'})
       return response
   })

   export const addCreditCards = createAsyncThunk('appDriverCreditCards/addCreditCards', async (CreditCard) => {
      const response = await axios.post('https://api.zasway.com:8443/Driver/CreateCard', CreditCard, {mode:'cors'})
      return response
   })

   export const editCreditCards  = createAsyncThunk('appDriverCreditCards/editCreditCards', async (CreditCard) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateCard', CreditCard, {mode:'cors'})
       
      return response
   })

   export const getCreditCardEditData = createAsyncThunk('appDriverCreditCards/getCreditCardEditData', async (params) => {
       
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverCreditCards', params, {mode:'cors'})
         
      return response
   })

   export const deleteCreditCard = createAsyncThunk('appDriverCreditCards/deleteCreditCard', async (id, { dispatch, getState }) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Driver/DeleteCard', id, {mode:'cors'})
         await dispatch(getData(getState().params))
           
         return response
   })

   export const appDriverCreditCardsSlice = createSlice({
      name: 'appDriverCreditCards',
      initialState: {
         data: [],
         allData: [],
         params: {},
         creditCardEditData: [],
         driverAdjustmentsEditData: []
      },
      reducers: {},
      extraReducers: builder => {
         builder

         .addCase(getData.fulfilled, (state, action) => {
            
            state.data = action.payload.data
            state.allData = action.payload.allData
            state.params = action.payload.params
         })

         .addCase(getCreditCardsData.fulfilled, (state, action) => {
            
            state.allData = action.payload.allData
            state.data = action.payload.data
         })

         .addCase(getCreditCardEditData.fulfilled, (state, action) => {
            
            state.creditCardEditData = action.payload.data
         })

         .addCase(editDriverAdjustments.fulfilled, (state, action) => {
            state.driverAdjustmentsEditData = action.payload.data
         })
      }
   })
  
export default appDriverCreditCardsSlice.reducer